import { render, staticRenderFns } from "./AutoManualSwitchWidget.vue?vue&type=template&id=350c332d"
import script from "./AutoManualSwitchWidget.vue?vue&type=script&lang=js"
export * from "./AutoManualSwitchWidget.vue?vue&type=script&lang=js"
import style0 from "./AutoManualSwitchWidget.vue?vue&type=style&index=0&id=350c332d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports